/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_h_act_moderate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate`)
};

const es_h_act_moderate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderado`)
};

const de_h_act_moderate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderat`)
};

const nl_h_act_moderate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matig actief`)
};

const fr_h_act_moderate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modéré`)
};

const it_h_act_moderate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderato`)
};

const pt_br2_h_act_moderate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderado`)
};

const pt_h_act_moderate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderado`)
};

const ja_h_act_moderate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`適度な運動`)
};

const zh_h_act_moderate = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中度活动`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const h_act_moderate = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.h_act_moderate(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("h_act_moderate", locale)
	if (locale === "en") return en_h_act_moderate(inputs)
	if (locale === "es") return es_h_act_moderate(inputs)
	if (locale === "de") return de_h_act_moderate(inputs)
	if (locale === "nl") return nl_h_act_moderate(inputs)
	if (locale === "fr") return fr_h_act_moderate(inputs)
	if (locale === "it") return it_h_act_moderate(inputs)
	if (locale === "pt-BR") return pt_br2_h_act_moderate(inputs)
	if (locale === "pt") return pt_h_act_moderate(inputs)
	if (locale === "ja") return ja_h_act_moderate(inputs)
	return zh_h_act_moderate(inputs)
};